import {
  LoginActionConst,
  SignupActionConst,
  OTPActionConst,
  PasswordOtpActionConst,
} from "../Constants/AuthConstants";

const initialState = {
  loader: false,
  loginSuccess: null,
  loginError: null,
  signupSuccess: null,
  signupError: null,
  user: null,
  pendingEmailForOTP: null,
  otpLoading: false,
  otpSuccess: null,
  otpError: null,
  pendingEmailForPasswordOtp: null,
  pendingOtpForPasswordReset: null,
  passwordOtpRequestLoading: false,
  passwordOtpRequestSuccess: null,
  passwordOtpRequestError: null,
  passwordOtpVerifyLoading: false,
  passwordOtpVerifySuccess: null,
  passwordOtpVerifyError: null,
  passwordOtpResetLoading: false,
  passwordOtpResetSuccess: null,
  passwordOtpResetError: null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LoginActionConst.USER_LOGIN_REQUEST:
      return {
        ...state,
        loader: true,
        loginError: null,
        loginSuccess: null,
      };

    case LoginActionConst.USER_LOGIN_SUCC:
      return {
        ...state,
        loader: false,
        loginSuccess: action.result,
        loginError: null,
        user: action.result.data,
      };

    case LoginActionConst.USER_LOGIN_FAIL:
      return {
        ...state,
        loader: false,
        loginError: action.result,
        loginSuccess: null,
        user: null,
      };

    case LoginActionConst.USER_LOGOUT:
      return {
        ...state,
        loader: false,
        loginSuccess: null,
        loginError: null,
        user: null,
      };

    case LoginActionConst.CLEAR_LOGIN_STATES:
      return {
        ...state,
        loader: false,
        loginSuccess: null,
        loginError: null,
      };

    case OTPActionConst.SET_PENDING_EMAIL_FOR_OTP:
      return {
        ...state,
        pendingEmailForOTP: action.payload,
      };

    case OTPActionConst.CLEAR_PENDING_EMAIL_FOR_OTP:
      return {
        ...state,
        pendingEmailForOTP: null,
        otpSuccess: null,
        otpError: null,
        otpLoading: false,
      };

    case OTPActionConst.VERIFY_EMAIL_REQUEST:
      return {
        ...state,
        otpLoading: true,
        otpError: null,
        otpSuccess: null,
      };

    case OTPActionConst.VERIFY_EMAIL_SUCCESS:
      return {
        ...state,
        otpLoading: false,
        otpSuccess: action.result,
        otpError: null,
      };

    case OTPActionConst.VERIFY_EMAIL_FAIL:
      return {
        ...state,
        otpLoading: false,
        otpError: action.result,
        otpSuccess: null,
      };

    case PasswordOtpActionConst.SET_PENDING_EMAIL:
      return {
        ...state,
        pendingEmailForPasswordOtp: action.payload,
      };

    case PasswordOtpActionConst.CLEAR_PENDING_EMAIL:
      return {
        ...state,
        pendingEmailForPasswordOtp: null,
        pendingOtpForPasswordReset: null,
      };

    case PasswordOtpActionConst.SET_PENDING_OTP:
      return {
        ...state,
        pendingOtpForPasswordReset: action.payload,
      };

    case PasswordOtpActionConst.CLEAR_PENDING_OTP:
      return {
        ...state,
        pendingOtpForPasswordReset: null,
      };

    case PasswordOtpActionConst.CLEAR_STATUS:
      return {
        ...state,
        passwordOtpRequestLoading: false,
        passwordOtpRequestSuccess: null,
        passwordOtpRequestError: null,
        passwordOtpVerifyLoading: false,
        passwordOtpVerifySuccess: null,
        passwordOtpVerifyError: null,
        passwordOtpResetLoading: false,
        passwordOtpResetSuccess: null,
        passwordOtpResetError: null,
        pendingOtpForPasswordReset: null,
      };

    case PasswordOtpActionConst.REQUEST_CODE:
      return {
        ...state,
        passwordOtpRequestLoading: true,
        passwordOtpRequestError: null,
        passwordOtpRequestSuccess: null,
      };

    case PasswordOtpActionConst.REQUEST_CODE_SUCCESS:
      return {
        ...state,
        passwordOtpRequestLoading: false,
        passwordOtpRequestSuccess: action.result,
        passwordOtpRequestError: null,
        pendingEmailForPasswordOtp: action.payload ?? state.pendingEmailForPasswordOtp,
      };

    case PasswordOtpActionConst.REQUEST_CODE_FAIL:
      return {
        ...state,
        passwordOtpRequestLoading: false,
        passwordOtpRequestError: action.result,
        passwordOtpRequestSuccess: null,
      };

    case PasswordOtpActionConst.VERIFY_REQUEST:
      return {
        ...state,
        passwordOtpVerifyLoading: true,
        passwordOtpVerifyError: null,
        passwordOtpVerifySuccess: null,
      };

    case PasswordOtpActionConst.VERIFY_SUCCESS:
      return {
        ...state,
        passwordOtpVerifyLoading: false,
        passwordOtpVerifySuccess: action.result,
        passwordOtpVerifyError: null,
      };

    case PasswordOtpActionConst.VERIFY_FAIL:
      return {
        ...state,
        passwordOtpVerifyLoading: false,
        passwordOtpVerifyError: action.result,
        passwordOtpVerifySuccess: null,
      };

    case PasswordOtpActionConst.RESET_REQUEST:
      return {
        ...state,
        passwordOtpResetLoading: true,
        passwordOtpResetError: null,
        passwordOtpResetSuccess: null,
      };

    case PasswordOtpActionConst.RESET_SUCCESS:
      return {
        ...state,
        passwordOtpResetLoading: false,
        passwordOtpResetSuccess: action.result,
        passwordOtpResetError: null,
      };

    case PasswordOtpActionConst.RESET_FAIL:
      return {
        ...state,
        passwordOtpResetLoading: false,
        passwordOtpResetError: action.result,
        passwordOtpResetSuccess: null,
      };

    case SignupActionConst.USER_SIGNUP_REQUEST:
      return {
        ...state,
        loader: true,
        signupError: null,
        signupSuccess: null,
      };

    case SignupActionConst.USER_SIGNUP_SUCC:
      return {
        ...state,
        loader: false,
        signupSuccess: action.result,
        signupError: null,
      };

    case SignupActionConst.USER_SIGNUP_FAIL:
      return {
        ...state,
        loader: false,
        signupError: action.result,
        signupSuccess: null,
      };

    default:
      return state;
  }
};

export default authReducer;
